var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 51,
    viewBox: "0 0 49 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M24.1345 50.5101C37.4636 50.5101 48.269 39.7047 48.269 26.3756C48.269 13.0464 37.4636 2.24106 24.1345 2.24106C10.8054 2.24106 0 13.0464 0 26.3756C0 39.7047 10.8054 50.5101 24.1345 50.5101Z",
    fill: "url(#paint0_radial_54_311)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9837 24.87V8.84928C33.9837 3.99368 30.0475 0.0574341 25.1918 0.0574341L9.17113 0.0574341C4.31552 0.0574341 0.379269 3.99368 0.379269 8.84928V24.87C0.379269 29.7256 4.31552 33.6619 9.17113 33.6619H25.1918C30.0475 33.6619 33.9837 29.7256 33.9837 24.87Z",
    fill: "#005A92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1138 26.3985L9.5159 21.1694C8.49772 19.3162 8.11693 17.1796 8.43219 15.0888C8.74745 12.9979 9.74128 11.0686 11.2606 9.59801C12.78 8.1274 14.7406 7.19699 16.8407 6.95005C18.9407 6.70311 21.0637 7.15331 22.8827 8.23136C24.7018 9.30941 26.116 10.9555 26.9077 12.9162C27.6994 14.8769 27.8246 17.0435 27.2641 19.0824C26.7036 21.1212 25.4884 22.9193 23.8057 24.1998C22.1229 25.4802 20.066 26.172 17.9515 26.1687C16.3477 26.1711 14.7684 25.7762 13.3544 25.0194L8.1138 26.3985ZM13.6302 23.0312L13.952 23.2266C15.4353 24.1067 17.1681 24.4714 18.8803 24.2639C20.5925 24.0564 22.1879 23.2883 23.418 22.0793C24.6481 20.8703 25.4437 19.2884 25.6808 17.5801C25.9179 15.8717 25.5832 14.1329 24.7289 12.6346C23.8745 11.1364 22.5486 9.96278 20.9576 9.2968C19.3666 8.63082 17.6 8.50986 15.9332 8.95275C14.2663 9.39565 12.7927 10.3775 11.7421 11.7454C10.6916 13.1132 10.123 14.7901 10.125 16.5149C10.1238 17.9477 10.5217 19.3525 11.2743 20.5718L11.4696 20.9051L10.6881 23.8242L13.6302 23.0312Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5372 17.825C21.3445 17.6747 21.1208 17.5689 20.8824 17.5152C20.6439 17.4616 20.3966 17.4614 20.1581 17.5147C19.8018 17.6641 19.5719 18.2273 19.3421 18.5146C19.2915 18.5821 19.218 18.6287 19.1354 18.6456C19.0528 18.6626 18.9669 18.6486 18.8939 18.6065C17.5827 18.093 16.4818 17.154 15.7679 15.9402C15.7017 15.8681 15.6649 15.7738 15.6649 15.6759C15.6649 15.578 15.7017 15.4837 15.7679 15.4116C16.0349 15.1593 16.2327 14.8427 16.3425 14.4922C16.3733 14.0925 16.2853 13.6927 16.0897 13.3429C15.8943 12.9407 15.6874 12.3545 15.2852 12.1247C15.0871 12.0389 14.8688 12.0107 14.6554 12.0432C14.442 12.0757 14.242 12.1677 14.0785 12.3086C13.8019 12.5461 13.5827 12.8432 13.4374 13.1776C13.2921 13.512 13.2244 13.875 13.2395 14.2393C13.2389 14.445 13.266 14.6499 13.3199 14.8484C13.4478 15.3231 13.6454 15.7763 13.9061 16.1931C14.0916 16.5145 14.295 16.8253 14.5152 17.124C15.2309 18.1125 16.1327 18.9518 17.17 19.5949C17.6899 19.921 18.2451 20.187 18.8249 20.3879C19.4304 20.6576 20.097 20.7607 20.7557 20.6867C21.1315 20.6314 21.4878 20.4839 21.7926 20.2572C22.0974 20.0306 22.3413 19.732 22.5025 19.388C22.5951 19.1788 22.6231 18.9467 22.583 18.7214C22.5255 18.3537 21.9164 18.0549 21.5372 17.825Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_54_311",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.1345 26.3756) scale(24.1345 24.1345)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#7373A2",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D9D9E6",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/Whatsapp Icon.c9169917e941ea75dc49bc5db49d33e3.svg";
export { ForwardRef as ReactComponent };